import {
    listEndpoint as endpoint,
    listClientId as clientId,
} from 'utils/settings';

type CallApiArguments = {
    query: string;
    token: string;
    variables?: Object;
};

export default function callAPI({
    token,
    query,
    variables,
}: CallApiArguments): Promise<Response> {
    return fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Client-Id': clientId,
        },
        body: JSON.stringify({
            query,
            variables,
        }),
    }).then(response => {
        if (!response.ok) {
            return response
                .json()
                .catch(() =>
                    Promise.reject(
                        new Error(
                            `${response.statusText} (${response.status}) when contacting ${endpoint}. Invalid response}`
                        )
                    )
                )
                .then(data =>
                    Promise.reject(
                        new Error(
                            `${response.statusText} (${
                                response.status
                            }) when contacting ${endpoint}. Response: ${JSON.stringify(
                                data
                            )}`
                        )
                    )
                );
        } else return response;
    });
}
